import { StyledButton } from './Close.styles';

function Close({ onClick, isMobileFullScreen = false }) {
  return <StyledButton onClick={onClick} isMobileFullScreen={isMobileFullScreen} />;
}
export default Close;
